module.exports = __webpack_public_path__ + "static/media/act-8.345596ac.pdf";